import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/outline';
import axiosInstance from '../../axios'
import NoImage from '../../assets/placeholder.jpg';
import imageAxios from '../../imageAxios';
const CentreDetails = () => {
  const navigate = useNavigate();
  const location=useLocation()
  const {id}=location.state||{}
  const [centre, setCentre] = useState({});
  const [imgSrc, setImgSrc] = useState('');
  const[check,setCheck]=useState('')
  const[doc,setDoc]=useState('')
  const [bank,setBank]=useState('')
  const[offer,setOffer]=useState('')
  const[caste,setCaste]=useState('')
  const [salary,setSalary]=useState('')
  const[photo,setPhotos]=useState([])
const[gumasta,setGumasta]=useState('')
const[trade,setTrade]=useState('')
const[proof,setProof]=useState('')
const[auth,setAuth]=useState('')
const[bankS,setBankS]=useState('')
const [firstSalary,setFirstSalary]=useState('')
const [secondSalary,setSecondSalary]=useState('')
const [thirdSalary,setThirdSalary]=useState('')
const [fourthSalary,setFourthSalary]=useState('')
const [fifthSalary,setFifthSalary]=useState('')
const [sixthSalary,setSixthSalary]=useState('')
// console.log(photo)
const[document,setDocument]=useState('')
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
  useEffect(() => {
    axiosInstance.get(`students/get/${id}`)
    .then((res) => {setCentre(res.data)
      //console.log(res.data)
      setImgSrc(`${imageAxios}/${res.data.image}`);
      setCheck(res.data.cancel_cheque?`${imageAxios}/${res.data.cancel_cheque}`:'')
      setDoc(res.data.documents?`${imageAxios}/${res.data.documents}`:'')
      setCaste(res.data.cast_certificate ? `${imageAxios}/${res.data.cast_certificate}` : '')
      setSalary(res.data.salary_slip?`${imageAxios}/${res.data.salary_slip}`:'')
      setBank(res.data.bank_statement?`${imageAxios}/${res.data.bank_statement}`:'')
      setGumasta(res.data.upload_gumasta?`${imageAxios}/${res.data.upload_gumasta}`:'')
      setOffer(res.data.offer_letter?`${imageAxios}/${res.data.offer_letter}`:'')
      setTrade(res.data.trade_license?`${imageAxios}/${res.data.trade_license}`:'')
      setProof(res.data.proof_enterprise_setup?`${imageAxios}/${res.data.proof_enterprise_setup}`:'')
      setAuth(res.data.authentication_proof?`${imageAxios}/${res.data.authentication_proof}`:'')
      setDocument(res.data.another_documentary_proof?`${imageAxios}/${res.data.another_documentary_proof}`:'')
      setBankS(res.data.additional_earning?`${imageAxios}/${res.data.additional_earning}`:'')
      setFirstSalary(res.data.first_salary_slip?`${imageAxios}/${res.data.first_salary_slip}`:'')
      setSecondSalary(res.data.second_salary_slip?`${imageAxios}/${res.data.second_salary_slip}`:'')
      setThirdSalary(res.data.third_salary_slip?`${imageAxios}/${res.data.third_salary_slip}`:'')
      setFourthSalary(res.data.fourth_salary_slip?`${imageAxios}/${res.data.fourth_salary_slip}`:'')
      setFifthSalary(res.data.fifth_salary_slip?`${imageAxios}/${res.data.fifth_salary_slip}`:'')
      setSixthSalary(res.data.sixth_salary_slip?`${imageAxios}/${res.data.sixth_salary_slip}`:'')
      const imageData = res.data.upload_business_photo;
        
        let imageArray = [];
      // console.log(imageArray)
        try {
          imageArray = JSON.parse(imageData);
        } catch (error) {
          console.error('Failed to parse image data:', error);
        }

        setPhotos(imageArray);
    })
    .catch((err) => console.log(err));
  }, [id]);
  const handleError = () => {
    setImgSrc(NoImage); // Path to your fallback image
  };
const date = new Date(centre.dob);
  const formattedDate = date.toLocaleDateString('en-US', { day: '2-digit', month: 'long', year: 'numeric' });
  const handleView = (url) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      alert('Document not found');
    }
  };
  const getEmploymentStatus = () => {
    if (centre.self_employed === 'Yes') {
      return 'Self Employed';
    } else if (centre.self_employed === 'No') {
      return 'Leased Employed';
    } else {
      return '';
    }
  };
  return (
    <div className="col-span-12 lg:col-span-10  flex justify-center ">
    <div className=" flex flex-col gap-5  w-11/12">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg  overflow-hidden">
        <div className="flex items-center justify-between bg-gray-100 p-4 border-b border-gray-400">
          <div className="flex items-center space-x-2">
            <ArrowLeftIcon
              className="w-6 h-6 text-gray-600 cursor-pointer hover:text-gray-800 transition"
              onClick={() => navigate('/students')}
            />
            <h1 className="text-xl font-semibold text-gray-700">Student Details</h1>
          </div>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-3  gap-6">
          <div className="flex flex-col row-span-2">
            <div className="text-gray-800 font-bold">Profile Picture
                <img
                  className="w-24 h-24 rounded-full object-cover"
                  src={imgSrc}
                  onError={handleError}
                  alt="Student Profile"
                 />
                
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Student Name</div>
              <div className="text-gray-600">{centre.fullname}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">SIP ID</div>
              <div className="text-gray-600">{centre.attendee_id}</div>
            </div>
           
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Candidate ID</div>
              <div className="text-gray-600">{centre.upsdm_id}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Gender</div>
              <div className="text-gray-600">{centre.gender}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Age</div>
              <div className="text-gray-600">{centre.age}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Marital Status</div>
              <div className="text-gray-600">{centre.marital_status}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Religion</div>
              <div className="text-gray-600">{centre.religion}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Contact no.</div>
              <div className="text-gray-600">{centre.contact_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Aadhar no.</div>
              <div className="text-gray-600">{centre.aadhar_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Email</div>
              <div className="text-gray-600">{centre.email}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">City</div>
              <div className="text-gray-600">{centre.city}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">District</div>
              <div className="text-gray-600">{centre.district}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Qualification</div>
              <div className="text-gray-600">{centre.qualification}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Sector</div>
              <div className="text-gray-600">{centre.sector_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Job Role Name</div>
              <div className="text-gray-600">{centre.job_role_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Batch Name</div>
              <div className="text-gray-600">{centre.batch_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Attendance</div>
              <div className="text-gray-600">{centre.tot_attended_hours}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Date of Birth</div>
              <div className="text-gray-600">{formattedDate}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank Name</div>
              <div className="text-gray-600">{centre.bank_name}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank Account No.</div>
              <div className="text-gray-600">{centre.bank_acc_no}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Bank Branch</div>
              <div className="text-gray-600">{centre.branch}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">IFSC Code</div>
              <div className="text-gray-600">{centre.ifsc_code}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Caste</div>
              <div className="text-gray-600">{centre.caste==='Gen'&&'General'}</div>
            </div>
            {centre.caste !== 'Gen' && (
  <div className="flex flex-col">
    <div className="text-gray-800 font-bold">Caste Certificate</div>
    <div className="text-gray-600">
      {caste ? (
        <button
          onClick={() => handleView(caste)}
          className="text-blue-500 hover:underline"
        >
          View Caste Certificate
        </button>
      ) : (
        'N/A'
      )}
    </div>
  </div>
)}

            <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Documents</div>
               <div className="text-gray-600">
                 {doc ? (
                   <button
                     onClick={() => handleView(doc)}
                     className="text-blue-500 hover:underline"
                   >
                     View Documents
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Cancelled Cheque</div>
               <div className="text-gray-600">
                 {check ? (
                   <button
                     onClick={() => handleView(check)}
                     className="text-blue-500 hover:underline"
                   >
                     View Cancelled Cheque
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Permanent Address</div>
              <div className="text-gray-600">{centre.permenent_address}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">District</div>
              <div className="text-gray-600">{centre.district}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Uniform Distribution</div>
              <div className="text-gray-600">{centre.uniform_distribution}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Study Material Distribution</div>
              <div className="text-gray-600">{centre.study_material_distribution}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Result</div>
              <div className="text-gray-600">{!centre.result_status ?'Pending':centre.result_status}</div>
            </div>
            <div className="flex flex-col">
              <div className="text-gray-800 font-bold">Placement Status</div>
              <div className="text-gray-600">{centre.is_placed}</div>
            </div>
            {centre.self_employed !== null && (
                <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">Employment Type</div>
                  <div className="text-gray-600">{getEmploymentStatus()}</div>
                </div>
              )}
            {centre.self_employed==='Yes'&&(
              <>
          
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Business Name</div>
                <div className="text-gray-600">{centre.name_of_business}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Address</div>
                <div className="text-gray-600">{centre.business_place_address}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Pincode</div>
                <div className="text-gray-600">{centre.business_pin_code}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">State</div>
                <div className="text-gray-600">{centre.business_state}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">District</div>
                <div className="text-gray-600">{centre.business_district}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">City</div>
                <div className="text-gray-600">{centre.business_city}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Business Start Date</div>
                <div className="text-gray-600">{formatDate(centre.business_start_date)}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Bank Details</div>
                <div className="text-gray-600">{centre.bank_details}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Beneficiary Mobile</div>
                <div className="text-gray-600">{centre.benificiary_mobile}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Turnover Till Date</div>
                <div className="text-gray-600">{centre.turnover_till_date}</div>
              </div>
              <div className="flex flex-col"> 
                <div className="text-gray-800 font-bold">Loan Availed</div>
                <div className="text-gray-600">{centre.loan_availed}</div>
              </div>
              {photo && photo.length > 0 && (
  <div className="flex flex-col col-span-3 space-y-4">
    <div className="text-gray-800 font-bold text-lg">Business Photos</div>
    <div className="flex flex-wrap gap-5">
      {photo.map((photo, index) => (
        <img
          key={index}
          src={`${imageAxios}/${photo.path.replace(/\\/g, '/')}`}
          alt={`Photo ${index + 1}`}
          className="m-2 h-40 w-40 object-cover rounded-sm shadow-lg hover:shadow-xl hover:scale-150 transition-shadow transition-transform duration-200 ease-in-out"
        />
      ))}
    </div>
  </div>
)}

              
              <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Proof Enterprise Setup</div>
               <div className="text-gray-600">
                 {proof ? (
                   <button
                     onClick={() => handleView(proof)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Gumasta Certificate</div>
               <div className="text-gray-600">
                 {gumasta ? (
                   <button
                     onClick={() => handleView(gumasta)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div> 
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Trade License</div>
               <div className="text-gray-600">
                 {trade ? (
                   <button
                     onClick={() => handleView(trade)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Authentication Proof</div>
               <div className="text-gray-600">
                 {auth ? (
                   <button
                     onClick={() => handleView(auth)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Bank Statement</div>
               <div className="text-gray-600">
                 {bankS ? (
                   <button
                     onClick={() => handleView(bankS)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Documentary Proof</div>
               <div className="text-gray-600">
                 {document ? (
                   <button
                     onClick={() => handleView(document)}
                     className="text-blue-500 hover:underline"
                   >
                     View
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
              </>
            )}
            {(centre.self_employed==='No' && centre.is_placed==='Placed')&&(
              <>
              
              <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Company Name</div>
                <div className="text-gray-600">{centre.company}</div>
                </div>
                <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Employer Name</div>
                <div className="text-gray-600">{centre.employer_name}</div>
                </div>
                <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Employer Email</div>
                <div className="text-gray-600">{centre.emp_email}</div>
                </div>
                <div className="flex flex-col">
                <div className="text-gray-800 font-bold">Employer Contact No.</div>
                <div className="text-gray-600">{centre.emp_contact_no}</div>
                </div>
                <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">Position</div>
                  <div className="text-gray-600">{centre.position}</div>
                </div>
                
             <div className="flex flex-col">
  <div className="text-gray-800 font-bold">Bank Statement</div>
  <div className="text-gray-600">
    {bank ? (
      <button
        onClick={() => handleView(bank)}
        className="text-blue-500 hover:underline"
      >
        View Bank Statement
      </button>
    ) : (
      'N/A'
    )}
  </div>
</div>

             <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Offer Letter</div>
               <div className="text-gray-600">
                 {offer ? (
                   <button
                     onClick={() => handleView(offer)}
                     className="text-blue-500 hover:underline"
                   >
                     View Offer Letter
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>

                </>)}
               
                {centre.is_placed==='Placed' &&(
                  <>

<div className="flex flex-col md:col-span-3 col-span-2">
              <p className='w-full bg-slate-600 p-1'></p>
              <p className="text-slate-800 font-bold text-2xl text-centre">Income/Salary Details</p>
            </div>
                  
                  <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">Basic CTC</div>
                  <div className="text-gray-600">{centre.salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">Salary Slip</div>
               <div className="text-gray-600">
                 {salary ? (
                   <button
                     onClick={() => handleView(salary)}
                     className="text-blue-500 hover:underline"
                   >
                     View Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">1st Month Salary</div>
                  <div className="text-gray-600">{centre.first_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">1st Month Salary Slip</div>
               <div className="text-gray-600">
                 {firstSalary ? (
                   <button
                     onClick={() => handleView(firstSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 1st Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">2nd Month Salary Amount</div>
                  <div className="text-gray-600">{centre.second_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">2nd Month Salary Slip</div>
               <div className="text-gray-600">
                 {secondSalary ? (
                   <button
                     onClick={() => handleView(secondSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 2nd Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">3rd Month Salary</div>
                  <div className="text-gray-600">{centre.third_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">3rd Month Salary Slip</div>
               <div className="text-gray-600">
                 {thirdSalary ? (
                   <button
                     onClick={() => handleView(thirdSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 3rd Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">4th Month Salary Amount</div>
                  <div className="text-gray-600">{centre.fourth_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">4th Month Salary Slip</div>
               <div className="text-gray-600">
                 {fourthSalary ? (
                   <button
                     onClick={() => handleView(fourthSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 4th Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">5th Month Salary</div>
                  <div className="text-gray-600">{centre.fifth_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">5th Month Salary Slip</div>
               <div className="text-gray-600">
                 {fifthSalary ? (
                   <button
                     onClick={() => handleView(fifthSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 5th Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             <div className="flex flex-col">
                  <div className="text-gray-800 font-bold">6th Month Salary</div>
                  <div className="text-gray-600">{centre.sixth_salary_amount}</div>
                </div>
                <div className="flex flex-col">
               <div className="text-gray-800 font-bold">6th Month Salary Slip</div>
               <div className="text-gray-600">
                 {sixthSalary ? (
                   <button
                     onClick={() => handleView(sixthSalary)}
                     className="text-blue-500 hover:underline"
                   >
                     View 6th Month Salary Slip
                   </button>
                 ) : (
                   'N/A'
                 )}
               </div>
             </div>
             
                  </>
                )}
                
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CentreDetails;
